/*
 * @Author: your name
 * @Date: 2021-02-07 13:40:50
 * @LastEditTime: 2021-12-02 15:59:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue3-element-admin\src\api\modules\system.js
 */
// const Mock = require("mockjs"); //引入
const config = require("../config")

module.exports = {
    login: {
        url: config.base_dev_site_url + "user/login",
        type: "post",
    },
    phoneLogin:{
        url: config.base_dev_site_url + "user/phone_login",
        type: "post",
    },
    devLogin:{
        url: config.base_dev_url + "mini_min_app_user/dev_login",
        type: "get",
    },
    getCfg: {
        url: config.base_dev_url + "cfg/get",
        type: "post",
    },
    getDeviceReceiverByAreaId: {
        url: config.base_dev_site_url + "deviceReceiver/getByAreaId/{areaId}",
        type: "post",
    },
    weather:{
        url:config.base_dev_site_url + "lz_weather7d/get",
        type:"get"
    },
    townList:{
        url: config.base_dev_site_url + "town/list",
        type:"get"
    },
    townDropdown:{
        url: config.base_dev_site_url + "town/dropdown",
        type:"get"
    },
    areaList:{
        url: config.base_dev_site_url + "lz_area/list",
        type:"get"
    },
    getTown:{
        url: config.base_dev_site_url + "town/get",
        type:"get"
    },
    getArea:{
        url: config.base_dev_site_url + "lz_area/get",
        type:"get"
    },
    getDistrict:{
        url: config.base_dev_site_url + "district/get",
        type:"get"
    },
    getGuangzhou:{
        url: config.base_dev_site_url + "district/getGuangzhou",
        type:"get"
    },
    findGuangzhouDistrict:{
        url: config.base_dev_site_url + "district/findGuangzhouDistrict",
        type:"get"
    }
};
